import { Fragment } from "react"

function  ErrorPage(){
    return(
        <Fragment>
            <p>Page not found</p>
        </Fragment>
    )
}
export default ErrorPage;